import React, { createContext } from 'react';

/**
 * Allows bypassing of readonly chart elements/properties, so that they can be edited by very
 * responsible users. Defaults to off (i.e. no bypass).
 */
export const ReadOnlyOverride = createContext<boolean>(false);

/**
 * Allows bypassing of readonly chart elements/properties, so that they can be edited by very
 * responsible users. As of the initial implementation, this is checked at the chart element level,
 * but it is applied indiscriminately to all chart properties.
 */
export const ReadOnlyOverrideProvider: React.FC = ({ children }) => {
  return <ReadOnlyOverride.Provider value>{children}</ReadOnlyOverride.Provider>;
};
